import React from "react";

const EnrolledContext = React.createContext()

export default EnrolledContext;